<template>
    <Modal :show-footer="false" :show-title="false" @cancel="close">
        <div class="limited-modal">
            <div class="limited-modal-title">
                <span class="material-icons alert-icon">notification_important</span>
                {{ $t("billing.youAreCurrentlyLimited") }}
            </div>
            <div class="limited-modal-description">
                <div class="limited-modal-description-text">
                    Tekrar erişim sağlamak için lütfen aşağıdaki koşulları sağlayınız.
                </div>
                <div class="limited-modal-description-content">
                    <div class="information-detail" v-if="shouldSelectPlan.supsisPackage">
                        <div class="information-detail-text">
                            - {{ $t("report.total") }} <b>{{ shouldSelectPlan.details.current.users }}</b>
                            {{ $t("billing.youHaveOneRepresentative") }}
                            <b>{{
                                shouldSelectPlan.details.current.users -
                                shouldSelectPlan.details.limit.currentSupsisAgentCount
                            }}</b>
                            {{ $t("billing.deactivateOrDeleteYourPiece") }}
                        </div>
                    </div>
                    <div class="information-detail" v-if="shouldSelectPlan.whatsappQr">
                        <div class="information-detail-text">
                            - {{ $t("report.total") }} <b>{{ shouldSelectPlan.details.current.whatsappQr }}</b>
                            {{ $t("billing.youHaveOneWhatsappQRChannel") }}
                            <b>
                                {{
                                    shouldSelectPlan.details.current.whatsappQr -
                                    shouldSelectPlan.details.limit.currentWhatsappPlanCount
                                }}</b
                            >
                            {{ $t("billing.deleteYourWhatsAppQR") }}
                        </div>
                    </div>
                    <div class="information-detail" v-if="shouldSelectPlan.whatsappBusiness">
                        <div class="information-detail-text">
                            - {{ $t("report.total") }}
                            <b>{{ shouldSelectPlan.details.current.whatsappBusinessChannels }}</b>
                            {{ $t("billing.youHaveAWhatsappBusiness") }}
                            <b>
                                {{
                                    shouldSelectPlan.details.current.whatsappBusinessChannels -
                                    shouldSelectPlan.details.limit.currentWhatsappBusinessChannelCount
                                }}</b
                            >
                            {{ $t("billing.deleteYourWhatsapp") }}
                        </div>
                    </div>
                    <div class="information-detail" v-if="shouldSelectPlan.instagram">
                        <div class="information-detail-text">
                            - {{ $t("report.total") }} <b>{{ shouldSelectPlan.details.current.instagram }}</b>
                            {{ $t("billing.youHaveAnInstagram") }}
                            <b>
                                {{
                                    shouldSelectPlan.details.current.instagram -
                                    shouldSelectPlan.details.limit.instagram
                                }}</b
                            >
                            {{ $t("billing.deleteYourInstagram") }}
                        </div>
                    </div>
                    <div class="information-detail" v-if="shouldSelectPlan.messenger">
                        <div class="information-detail-text">
                            - {{ $t("report.total") }} <b>{{ shouldSelectPlan.details.current.messenger }}</b>
                            {{ $t("billing.youHaveAMessenger") }}
                            <b>
                                {{
                                    shouldSelectPlan.details.current.messenger -
                                    shouldSelectPlan.details.limit.messenger
                                }}</b
                            >
                            {{ $t("billing.deleteYourMessenger") }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="limited-modal-footer">
                <SupsisButton @click="close" primary>Kapat</SupsisButton>
            </div>
        </div>
    </Modal>
</template>
<script>
import Modal from "../../../../components/common/Modal2.vue";
import { mapGetters } from "vuex";
import SupsisButton from "../../Settings/components/SupsisButton.vue";

export default {
    name: "LimitedModal",
    components: {
        SupsisButton,
        Modal,
    },
    methods: {
        close() {
            this.$emit("cancel");
        },
        confirm() {
            this.$emit("confirm");
        },
    },
    computed: {
        ...mapGetters({
            shouldSelectPlan: "setting/shouldSelectPlan",
        }),
    },
};
</script>
<style lang="scss" scoped>
.limited-modal {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 30px;

    .alert-icon {
        font-size: 42px;
        color: rgb(250, 102, 102);
    }

    &-title {
        font-size: medium;
        text-align: center;
        font-weight: bold;
        text-transform: uppercase;
        display: flex;
        flex-direction: column;
        gap: 5px;
    }

    &-description {
        display: flex;
        flex-direction: column;
        gap: 10px;

        &-text {
            font-size: 16px;
            font-weight: 500;
        }

        &-content {
            font-size: 14px;
            font-weight: 300;
            display: flex;
            flex-direction: column;
            gap: 10px;
        }
    }
}
</style>
